





















































































































































































import { Component, Mixins, Prop } from "vue-property-decorator";

// Mixins
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { ApiOperators } from "@/data/table";
import { DefaultInvoicesFilters } from "@/data/filters/invoice";
import { DefaultInvoicesSorters } from "@/data/sorters/invoices";
import { Sorters } from "@/data/table";

// Types
import { IInvoice } from "@/models/invoices";
import { ITableConfig, IFilter, ISorter } from "@/models/tables";

@Component({
  components: {
    "order-items-summary": () =>
      import("@/components/app/global/orders/orderItemsSummary.vue")
  }
})
export default class SelectOrders extends Mixins(FilteringSortingTableStore) {
  // Props

  @Prop({ default: null })
  public selectedOrderId!: IInvoice["id"] | null;

  @Prop({ default: "SOT1" })
  public declare id: string;

  @Prop({ default: true })
  public declare ignoreHistory: boolean;

  @Prop({ default: true })
  public declare enableFiltering: boolean;

  @Prop({ default: () => ({}) })
  public readonly manualFilters!: { [key: string]: string | number | boolean };

  // Variables

  public dataModule = DataModules.INVOICES_BASKETS;

  public defaults: ITableConfig = {
    limit: 10,
    sort: {
      field: "id",
      direction: Sorters.DESCENDING
    },
    filters: []
  };

  public debounceSearch = this.$_.debounce(this.doQuickSearch, 250);
  public searchQuery = "";
  public filters: IFilter[] = DefaultInvoicesFilters();
  public sorters: ISorter[] = DefaultInvoicesSorters();

  public selectedId = this.selectedOrderId;

  // Life-cycle methods

  public created() {
    if (!this.contentIsAvailable) return;

    this.apiProps = {
      with: "products,client,client.image",
      "filter[abandoned]": false,
      ...this.manualFilters
    };
    this.getData();
  }

  // Methods

  public reloadData() {
    this.getData({ ignoreStored: true });
  }

  public onSelect(id) {
    this.selectedId = id;
    this.$emit("selected", id);
  }

  public getStoreParams(params: any): Promise<any> {
    return this.$_.merge(
      {
        params: {
          with: "products,client,client.image",
          "filter[abandoned]": false,
          ...this.queryFilter
        }
      },
      params // Important – must merge last
    );
  }

  public async doQuickSearch(value = "") {
    if (value === this.searchQuery) return Promise.resolve();
    this.searchQuery = value;

    return this.getData({
      ignoreStored: true,
      page: 1
    });
  }

  public getDate(value) {
    return `${this.$moment
      .utc(value)
      .local()
      .format(this.$t("_datetime.date.long").toString())}`;
  }

  // Computed

  public get queryFilter() {
    return this.searchQuery
      ? { [`filter[number|${ApiOperators.LIKE}]`]: `%${this.searchQuery}%` }
      : {};
  }

  // Guarding

  public guardFunctionalities = ["staff_list_invoices"];

  public get contentIsAvailable() {
    return this.$userCan(...this.guardFunctionalities);
  }
}
